import {
  fetchCartCount,
} from '@fetch/shopping';

const state = {
  count: 0,
  exts: [1,2,3,4,5],
  healthgoodsFlag: 0,
};

const getters = {
  getCount: state => state.count,
  exts: state => state.exts,
  healthgoodsFlag: state => state.healthgoodsFlag,
};

const actions = {
  async cartCount({ commit }, data) {
    const res = await fetchCartCount(data);
    try {
      if (res && typeof res !== 'object') {
        commit('incrementAsync', res);
      }
    } catch (error) {
      commit('incrementAsync', 0);
    }
  },
  changeExts({ commit }, item) {
    commit('changeExts', item);
  },
  changeMallgoodsList({ commit }, item) {
    commit('changeHealthgoodsFlag', item);
  },
};

const mutations = {
  incrementAsync(state, count) {
    state.count = count;
  },
  changeExts(state, item) {
    state.exts = item;
  },
  changeHealthgoodsFlag(state, item) {
    state.healthgoodsFlag = item;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};